// 検索期間のワンクリックプリセット(純関数)。ラベルと期間を返すだけで、適用は呼び出し側。
// 期(今期/前期)は fiscalYear.js(6月1日はじまり)に一本化されたルールを使う。
import { getFiscalYear } from "../deducation/fiscalYear";
import { getDefaultRange } from "./orderSearchModel";

// 期末(5/31 23:59:59.999)などを日付単位に丸める(検索条件は日単位で持つため)
const toDayPrecision = (date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

export const getDatePresets = (now = new Date()) => {
  const defaultRange = getDefaultRange(now);
  const thisMonthFrom = new Date(now.getFullYear(), now.getMonth(), 1);
  const thisMonthTo = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  const lastMonthFrom = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const lastMonthTo = new Date(now.getFullYear(), now.getMonth(), 0);
  const currentFiscal = getFiscalYear(now);
  // 前期 = 今期の期首の1ミリ秒前が属する期
  const previousFiscal = getFiscalYear(
    new Date(currentFiscal.start.getTime() - 1)
  );

  return [
    {
      id: "last3Months",
      label: "過去3ヶ月",
      from: defaultRange.from,
      to: defaultRange.to,
      title: "2ヶ月前の月初〜今月末(既定の期間)",
    },
    { id: "thisMonth", label: "今月", from: thisMonthFrom, to: thisMonthTo },
    { id: "lastMonth", label: "先月", from: lastMonthFrom, to: lastMonthTo },
    {
      id: "thisFiscal",
      label: `今期(${currentFiscal.label})`,
      from: toDayPrecision(currentFiscal.start),
      to: toDayPrecision(currentFiscal.end),
      title: currentFiscal.rangeLabel,
    },
    {
      id: "prevFiscal",
      label: `前期(${previousFiscal.label})`,
      from: toDayPrecision(previousFiscal.start),
      to: toDayPrecision(previousFiscal.end),
      title: previousFiscal.rangeLabel,
    },
  ];
};
